import actions from "./actions";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  isFetching: false,
  actionType: null,
  errorMessage: "",
  successMessage: "",
  myDonationsList: [],
  Year:[]
});

export default function myDonationsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.My_DONATIONS_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
      });
    case actions.MY_DONATIONS_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "MY_DONATIONS_SUCCESS",
        myDonationsList: action.myDonationsList,
      });
    case actions.MY_DONATIONS_ERROR:
      return Immutable.merge(state, {
        failure: true,
        isFetching: false,
        errorMessage: action.errorMessage,
      });
    case actions.DOWNLOAD_PDF_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
      });

    case actions.DOWNLOAD_PDF_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        successMessage: action.message, // Add success message if needed
        status_code: action.status_code, // Add status code if needed
        actionType: "DOWNLOAD_PDF_REQUEST",
      });

    case actions.DOWNLOAD_PDF_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        errorMessage: action.payload.error, // Ensure correct access
        status_code: action.payload.status_code, // Add status code if needed
        actionType: "DOWNLOAD_PDF_ERROR",
      });

    case actions.GET_YEAR_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
      });
    case actions.GET_YEAR_SUCCESS:
      return Immutable.merge(state, {
        actionType: "GET_YEAR_SUCCESS",
        YEAR: action.data,
      });
    case actions.GET_YEAR_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: "GET_YEAR_ERROR",
        errorMessage: action.errorMessage,
      });

      case actions.RESET_ACTIONTYPE:
        return Immutable.merge(state, {
          actionType: '',
          status_code: 0,
          errorMessage: '',
          myDonationsList:[]
        })

    default:
      return state;
  }
}
